/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { Dispatch, ReactNode, SetStateAction, useCallback, useEffect, useRef, useState } from "react";
import { Container, Table, Button, Flex } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { ReadonlyURLSearchParams, useSearchParams } from "next/navigation";
import { getApiHostname, getParamsValue } from "@/util/paramutil";
import Pagination from "@/components/layout/data/list/pagination";
import {
  AlertProps,
  AuthLayoutProps,
  ListButton,
  ListClickButton,
  ListEdit,
  ListEditField,
  ListEditType,
  ListParams,
  TransitionType,
} from "@/components/layout/layoutType";
import { DataCols, DataColumn, DatePickerTypeArray, InputTypeValue } from "@/components/layout/input/inputType";
import { checkMobile } from "@/util/checkMobile";
import { fetchHost, fetchStatusText, fetchUtil } from "@/util/fetchutil";
import { Debug } from "@/util/debug";
import { initDataColCheck, initDataCols } from "../data";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { getDataStatusText, getNoData } from "@/util/datautil";
import { cn } from "@/lib/utils";
import {
  checkColsValueListChange,
  checkDisplayCommon,
  checkListButtonDisplay,
  checkValueList,
  convertCalcValue,
  convertInputTypeValue,
  getCodeLabel,
  getColsGroups,
  GetDataInputElement,
  getDayjsValueStr,
  getTransitionValueLabel,
  getValueLabel,
} from "../../input/inputFunction";
import { getCodeGroups } from "@/util/code";
import { addUserAuthSelect } from "@/util/authutil";
import { Collapse, CollapseProps, Form, Switch, Button as AntdButton } from "antd";
import { FormInstance, useForm } from "antd/es/form/Form";
import DataInput from "../dataInput";
import * as dc from "@/components/layout/list/defaultType";
import Select, { DefaultOptionType } from "antd/es/select";
import { checkEmpty, checkEmptyValue, linkFieldConvert } from "@/util/stringutil";
import { Dayjs } from "dayjs";
import { mergeArr } from "@/util/arrayutil";
import React from "react";

import { Skeleton } from "@radix-ui/themes";
import Icon from "@/components/common/icon/icon";
import { appRouterPush } from "@/util/apputil";
import { unwatchFile } from "fs";
import DataSwitch from "../../input/switch";
// import dynamic from "next/dynamic";
// const Skeleton = dynamic(() => import("@radix-ui/themes").then((mod) => mod.Skeleton), { ssr: false });
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

const dv = require("@datas/default.json");
//"/api/roaster/roasting/result/instock/update"
const listClickMultiDefault = 3;
export const listEditClickCommon = (
  t: TransitionType,
  ta: TransitionType,
  dataFunction: Record<string, Function> | undefined,
  alertContext: AlertProps | undefined,
  url: string,
  auth: AuthLayoutProps | undefined,
  fieldName: string,
  chageValues: any[] | undefined,
  resultName?: string | undefined,
) => {
  const alert_p = alertContext?.setProp;
  if (alert_p) {
    if (chageValues) {
      // Debug(chageValues, changeData);
      const data: any = {};
      data[fieldName] = chageValues;
      alert_p({
        open: true,
        title: ta("save"),
        description: ta("save_count_value", { value: chageValues.length }),
        useCancel: true,
        useOk: true,
        okClose: false,
        okFunction: () => {
          const fetchOption = { ...dc.fetchPostOption, body: JSON.stringify({ instock_list: chageValues }) };
          fetchHost(
            url,
            fetchOption,
            auth,
            (data: any) => {
              // Debug(data);
              const edit_result = data.result[resultName ?? "edit_result"];
              if (data.status === "OK" && edit_result) {
                setTimeout(() => {
                  alert_p({
                    open: true,
                    title: ta("save"),
                    description: ta("save_count_ok", { value: edit_result }),
                    useCancel: false,
                    useOk: true,
                    okFunction: () => {
                      alert_p({ open: false, loading: false });
                    },
                  });
                  if (dataFunction && dataFunction["setListEditSaved"]) {
                    dataFunction["setListEditSaved"]();
                  }
                }, 150);
              } else {
                const nodata_text = data.description ?? fetchStatusText(data.status, false);
                alert_p({
                  open: true,
                  title: ta("error"),
                  description: t(nodata_text),
                  useCancel: false,
                  useOk: true,
                  okFunction: () => {},
                });
              }
            },
            () => {
              alert_p({
                open: true,
                title: ta("error"),
                description: ta("error_text"),
                useCancel: false,
                useOk: true,
                okFunction: () => {},
              });
            },
          );
        },
      });
    } else {
      Debug("change values is zero");
      alert_p({
        open: true,
        title: ta("save"),
        description: ta("save_not_changed"),
        useCancel: false,
        useOk: true,
        //okFunction: () => {},
      });
    }
  }
};

const checkListShow = (listMode: string | undefined, listShow?: boolean | string | string[]): string => {
  if (listShow === undefined) {
    return listMode === "view" ? "" : "hidden";
  } else if (listShow instanceof Array) {
    return listMode && listShow.includes(listMode) ? "" : "hidden";
  } else if (typeof listShow === "string") {
    return listMode === listShow ? "" : "hidden";
  } else {
    return listShow ? "" : "hidden";
  }
};
const getListEdit = (listEdit: ListEdit[], listEditMode: string | undefined) => {
  const result: Record<string, { field: Record<string, ListEditType>; onChange?: Function; button?: ListButton }> = {};
  const fields: Record<string, string[]> = {};
  listEdit.map((item) => {
    if (typeof item.field === "string") {
      const mode = item.mode ?? item.field;
      result[mode] = {
        field: {},
        onChange: item.onChange,
        button: item.button,
      };
      result[mode].field[item.field] = item.type ?? "switch";
      fields[item.field] = [mode];
    } else if (item.field instanceof Array) {
      const mode = item.mode ?? "";
      result[mode] = {
        field: {},
        onChange: item.onChange,
        button: item.button,
      };
      item.field.forEach((field) => {
        result[mode].field[field] = item.type ?? "switch";
        if (fields[field]) {
          fields[field].push(mode);
        } else {
          fields[field] = [mode];
        }
      });
    } else {
      const mode = item.mode ?? "";
      result[mode] = {
        field: { ...item.field },
        onChange: item.onChange,
        button: item.button,
      };
      if (item.field) {
        Object.keys(item.field).forEach((field) => {
          if (fields[field]) {
            fields[field].push(mode);
          } else {
            fields[field] = [mode];
          }
        });
      }
    }
  });

  return { listEdit: listEditMode ? result[listEditMode] : undefined, listEditFields: fields };
};
const getSummaryValue = (
  t: TransitionType | undefined,
  col: DataColumn,
  codeGroups: Record<string, any[]> | null | undefined,
  item: any,
  locale: string | undefined,
  blank?: boolean,
) => {
  const temp_value =
    item && item[col.field] !== undefined && item[col.field] instanceof Object && item[col.field].$$typeof !== undefined
      ? item[col.field]
      : col.codeGroup === undefined
        ? col.valueList
          ? getTransitionValueLabel(item[col.field], col.valueList, t, col.transition)
          : convertCalcValue(item[col.field], item, col.calcValueProp, col.inputType, col.scale, col.dateFormatter, col.sign)
        : item[col.field];
  if (blank && checkEmpty(temp_value)) {
    return undefined;
  }
  const prev = col.prev ? (GetDataInputElement(col.prev, false, item, t) as string) : "";
  const next = col.next ? (GetDataInputElement(col.next, true, item, t) as string) : "";
  const unitPrev = col.unitPrev ? (GetDataInputElement(col.unitPrev, false, item, t) as string) : "";
  const unit = col.unit ? (GetDataInputElement(col.unit, true, item, t) as string) : "";
  //   Debug(col.field, col.inputType, item[col.field], typeof item[col.field]);
  const value = !checkEmpty(temp_value)
    ? temp_value.$$typeof !== undefined
      ? temp_value
      : col.codeGroup
        ? prev + unitPrev + getCodeLabel({ ...col, value: item[col.field], values: item, codeGroups, locale }, true) + unit + next
        : prev + unitPrev + temp_value + unit + next
    : undefined;
  if (checkEmpty(value)) {
    return undefined;
  } else {
    return (col.prevNewLine ? (typeof col.prevNewLine === "string" ? col.prevNewLine : "\r\n") : "") + value;
  }
};
export const getSummaryValues = (
  t: TransitionType | undefined,
  col: string | string[] | DataColumn,
  codeGroups: Record<string, any[]> | null | undefined,
  item: any,
  locale: string | undefined,
  blank?: boolean,
) => {
  const tempCol: DataColumn = typeof col === "string" ? { field: col } : col instanceof Array ? { field: col[0] } : col;
  if (col instanceof Array) {
    tempCol.fieldId = {};
    col.forEach((id) => {
      if (tempCol.fieldId && tempCol.fieldId instanceof Object) {
        tempCol.fieldId[id] = {};
      }
    });
  }
  const tempColFieldId = tempCol.fieldId && typeof tempCol.fieldId !== "string" ? tempCol.fieldId : undefined;
  const value = checkEmptyValue(
    tempColFieldId
      ? Object.keys(tempColFieldId).map((id) => {
          const tempId = tempColFieldId[id].fieldId && typeof tempColFieldId[id].fieldId === "string" ? tempColFieldId[id].fieldId : id;
          return getSummaryValue(t, { ...tempColFieldId[id], field: tempId }, codeGroups, item, locale, blank);
        })
      : [getSummaryValue(t, tempCol, codeGroups, item, locale, blank)],
  )
    .filter((item: any) => !checkEmpty(item))
    .join(tempCol.valueJoin ?? ",");
  if (blank && checkEmpty(value)) {
    return undefined;
  }
  return value;
};
const getTableCell = (
  t: TransitionType,
  params: ListParams,
  col: DataColumn,
  codeGroups: Record<string, any[]> | null | undefined,
  linkFieldValue: any,
  item: any,
  index: number,
  colIndex: number,
  tableClass: string,
  addClass: string | undefined,
  boldFields: string[] | undefined,
  listEdit: ListEditField | undefined,
  loading?: boolean,
  blank?: boolean,
  colspan?: number,
) => {
  const editMode = listEdit ? listEdit.field[col.field] : undefined;
  const value =
    editMode && editMode === "switch" ? (
      <DataSwitch
        {...{
          field: col.field,
          name: linkFieldValue + "_" + col.field,
          value: item[col.field],
          values: item,
          inputMode: "edit",
          inputClassName: "!mt-0 mb-1",
          onChange(event) {
            Debug(event);
            if (listEdit?.onChange) {
              listEdit?.onChange(event);
            }
          },
        }}
      />
    ) : (
      getSummaryValues(t, col, codeGroups, item, params.locale, blank)
    );
  if (blank && checkEmpty(value)) {
    return undefined;
  }
  const tableClassStr = checkEmpty(tableClass) ? "table" : tableClass;
  return (
    <Table.Cell
      key={params.listName + "_" + index + "_" + col.field}
      className={cn(
        tableClassStr + "-row-" + index,
        tableClassStr + "-cell-" + colIndex,
        tableClassStr + "-field-" + col.field,
        boldFields && boldFields.includes(col.field) ? "font-bold" : "",
        "align-middle",
        editMode ? "py-2" : "",
        col.className,
        col.itemClassName,
        addClass,
      )}
      colSpan={colspan}
    >
      <Skeleton loading={loading}>{value}</Skeleton>
    </Table.Cell>
  );
};
const getTableCellList = (
  t: TransitionType,
  params: ListParams,
  cols: string | DataColumn | (string | DataColumn)[],
  codeGroups: Record<string, any[]> | null | undefined,
  linkFieldValue: any,
  item: any,
  index: number,
  colIndex: number,
  tableClass: string,
  addClass: string | undefined,
  boldFields: string[] | undefined,
  loading?: boolean,
  blank?: boolean,
  colspan?: number,
) => {
  const tempCols = cols instanceof Array ? cols : [cols];
  // const result = [];
  const result = tempCols
    .map((col) => {
      const tempcol = typeof col === "string" ? { field: col } : col;
      const cell = getTableCell(
        t,
        params,
        tempcol,
        codeGroups,
        linkFieldValue,
        item,
        index,
        colIndex,
        tableClass,
        addClass,
        boldFields,
        undefined,
        loading,
        blank,
        colspan,
      );
      return cell ? { col: tempcol, cell } : undefined;
    })
    .filter((item) => item !== undefined);

  // Debug("getTableCellList", result);

  return checkEmpty(result) ? undefined : result;
};
const changeSelectValue = (formName: string, value: any) => {
  if (document) {
    const search_select = document.querySelectorAll("." + formName + " .ListSearchInputSelect");
    Debug(value, search_select);
    if (checkEmpty(value)) {
      search_select.forEach((search) => search.classList.add("hidden"));
    } else if (value === "search_all") {
      search_select.forEach((search) => search.classList.remove("hidden"));
    } else if (value !== undefined) {
      search_select.forEach((search) => search.classList.add("hidden"));
      const search_select_show = document.querySelectorAll("." + formName + " .ListSearchInputSelect.list_" + value);
      search_select_show.forEach((search) => search.classList.remove("hidden"));
    }
  }
};
const getColsDefaultValue = (cols: DataColumn[], exField?: string[]) => {
  const defaultValue: Record<string, any> = {};
  cols.forEach((col) => {
    const field = col.field;
    if (!exField || !exField.includes(field)) {
      if (col.defaultValue) {
        defaultValue[field] = col.defaultValue;
      } else {
        if (col.valueList) {
          col.valueList.some((item, index) => {
            if (index === 0) defaultValue[field] = item.value;
            return true;
          });
        }
      }
    }
  });
  return defaultValue;
};
const getAPISearchParamsValue = (
  searchParams: ReadonlyURLSearchParams | undefined,
  searchCols: DataColumn[],
  orderCols: DataColumn[] | undefined,
  //  exField?: string[],
) => {
  const exField = ["searchSelect", "searchType", "searchButton"];
  const params = new URLSearchParams(searchParams?.toString());
  const cols = orderCols ? [...searchCols, ...orderCols] : searchCols;
  const colMap: Record<string, DataColumn> = {};
  let hasSearchType = false;
  cols.forEach((item) => {
    if (item.field === "searchType") hasSearchType = true;
    colMap[item.field] = item;
  });

  //선택값 확인
  // for (const [key, value] of params.entries()) {
  //   if (colMap[key] && colMap[key].valueList) {
  //     //const value = params.get(key);
  //     if (checkValueList(colMap[key].valueList, value) === undefined) {
  //       params.delete(key);
  //     }
  //   }
  // }
  const keys = Array.from(params.keys());
  keys.forEach((key) => {
    if (colMap[key] && colMap[key].valueList) {
      const value = params.get(key);
      if (checkValueList(colMap[key].valueList, value) === undefined) {
        params.delete(key);
      }
    }
  });
  // params.keys().forEach((key) => {
  // });

  //기본값 주입
  const defaultValue: Record<string, any> = getColsDefaultValue(cols, exField);
  Object.keys(defaultValue).forEach((key) => {
    if (key !== "searchSelect") {
      if (!params.has(key)) {
        params.append(key, defaultValue[key]);
      } else if (checkEmpty(params.get(key))) {
        params.set(key, defaultValue[key]);
      }
    }
  });
  if (hasSearchType) {
    if (!params.has("searchTitle") || checkEmpty(params.get("searchTitle"))) {
      params.delete("searchType");
    }
    if (!params.has("searchType") || checkEmpty(params.get("searchType"))) {
      params.delete("searchTitle");
    }
  }
  //checkValueList
  return params;
};
const hasSearchNoValue = (list: (string | undefined)[], values: any) => {
  if (!checkEmpty(values["searchSelect"])) {
    const uncheck = ["searchSelect", "searchType", "searchTitle", "searchButton"];
    return list.some((item) => {
      return item !== undefined && !uncheck.includes(item) && values[item] !== undefined;
    });
  } else {
    return true;
  }
};
const getOrderCountCols = (
  t: TransitionType,
  listOrder: boolean | DataCols | undefined,
  listOrderInputClassName: string | undefined,
  listCount: boolean | number[] | undefined,
  listCountInputClassName: string | undefined,
  isMobile?: boolean,
): DataColumn[] | undefined => {
  const orderCols: DataColumn[] | undefined =
    typeof listOrder !== "boolean"
      ? initDataColCheck(listOrder)
      : listOrder
        ? [{ field: "rgst_at_orderdesc" }, { field: "rgst_at_orderasc" }]
        : undefined;
  const listCountCols: number[] | undefined =
    listCount instanceof Array ? listCount : (listCount ?? true) ? (isMobile ? [5, 10, 20, 30, 50] : [10, 20, 30, 50, 100]) : undefined;
  const result: DataColumn[] = [];
  if (orderCols || listCountCols) {
    if (orderCols) {
      const valueList: DefaultOptionType[] = [];
      orderCols.forEach((item) => {
        const label = item.label ? (typeof item.label !== "string" ? item.label?.element.toString() : item.label) : undefined;
        let labelIconName = "SortAscending";
        let str = item.field;
        const obj: { value: string | number; label: ReactNode; label_str: string } = { value: item.field, label: "", label_str: "" };
        if (item.field.indexOf("_orderdesc") === item.field.length - 10) {
          str = label ?? item.field.substring(0, item.field.length - 10);
          labelIconName = "SortDescending"; //" ↑";
        } else if (item.field.indexOf("_orderasc") === item.field.length - 9) {
          str = label ?? item.field.substring(0, item.field.length - 9);
          labelIconName = "SortAscending"; //" ↓";
        }
        valueList.push({
          value: item.field,
          label: (
            <span>
              {t(str)}
              <Icon iconType="" iconName={labelIconName} className="inline ml-1 mb-1" />
            </span>
          ),
          label_str: str,
        });
      });
      if (valueList.length > 0) {
        result.push({
          field: "orderType",
          inputType: "select",
          placeholder: "order_type",
          tooltip: "order_type",
          valueList: valueList,
          defaultValue: valueList[0].value,
          variant: "filled",
          allowClear: false,
          selectProp: { suffixIcon: <></>, styles: { popup: { root: { textAlign: "end" } } }, popupMatchSelectWidth: true },
          inputClassName: listOrderInputClassName ?? "text-right",
        });
      }
    }

    if (listCountCols) {
      const valueList: DefaultOptionType[] = [];
      listCountCols.forEach((item) => {
        const label = t("list_count_value", { value: item });
        valueList.push({ value: item, label: label, label_str: label });
      });
      if (valueList.length > 0) {
        result.push({
          field: "list_count",
          inputType: "select",
          placeholder: "list_count",
          tooltip: "list_count",
          valueList: valueList,
          defaultValue: valueList[0].value,
          variant: "filled",
          allowClear: false,
          selectProp: { suffixIcon: <></>, styles: { popup: { root: { textAlign: "end" } } } },
          inputClassName: listCountInputClassName ?? "min-w-[4.5rem]",
        });
      }
    }
  }
  //Debug(result, orderCols, pageCountCols);
  if (result.length > 0) {
    return result;
  }
  return undefined;
};
const getSearchCols = (formName: string, params: ListParams, searchSelect: string, t: TransitionType) => {
  const listSearch: DataColumn[] | undefined = params.listSearch ? initDataColCheck(params.listSearch) : undefined;
  const listSearchAll: boolean = params.listSearchAll ?? dv.listSearchAll;
  const searchCols: DataColumn[] = listSearch
    ? listSearch.map((item: DataColumn) => {
        const label = typeof item.label !== "string" ? item.label?.element.toString() : item.label;
        return {
          ...item,
          itemClassName: cn(
            item.itemClassName,
            listSearchAll || listSearch.length === 1
              ? ""
              : (searchSelect === item.field || searchSelect === "search_all" ? "" : "hidden ") +
                  "ListSearchInputSelect list_" +
                  item.field,
          ),
          tooltip: label,
          selectPropOption: { ...item.selectPropOption, reloadButton: item.selectPropOption?.reloadButton ?? false },
        };
      })
    : [];
  const listSelect = params.listSearchSelect ? initDataColCheck(params.listSearchSelect) : undefined;
  if (listSelect) {
    const valueList: DefaultOptionType[] = listSelect
      .map((item) => {
        const str = typeof item.label !== "string" ? (item.label?.element.toString() ?? item.field) : (item.label ?? item.field);
        const label = t(str);
        return { value: item.field, label: label, label_str: label };
      })
      .filter((item) => item !== undefined);
    if (valueList.length > 1) {
      valueList.unshift({ value: "search_title_all", label: t("search_title_all"), label_str: t("search_title_all") });
    }
    if (valueList.length > 1) {
      searchCols.push({
        field: "searchType",
        inputType: "select",
        placeholder: "search_title",
        tooltip: "search_title",

        valueList: valueList,
        defaultValue: valueList[0].value,
        itemClassName: valueList.length > 1 ? "" : " hidden",
        inputClassName: params.listSearchSelectClassName ?? dc.searchSelectWidth,
      });
    }
    searchCols.push({
      field: "searchTitle",
      inputType: "input",
      placeholder: valueList.length > 1 ? "search_title_input" : (valueList[0].value ?? "") + "",
      tooltip: valueList.length > 1 ? "search_title_input" : (valueList[0].value ?? "") + "",
      inputClassName: "searchTitle",
    });
  }
  if (searchCols.length > 0) {
    const modeValueList =
      !listSearchAll && listSearch && listSearch.length > 1
        ? [
            //listSelect ? { value: "search_title", label: "search_title", label_str: "search_title" } : undefined,
            ...listSearch
              .map((item) => {
                const label = typeof item.label !== "string" ? (item.label?.element.toString() ?? item.field) : (item.label ?? item.field);
                const t_label = label ? t(label) : undefined;
                return { value: item.field, label: t_label ?? item.field, label_str: t_label ?? item.field };
              })
              .filter((item) => item !== undefined),
            { value: "search_all", label: t("search_all"), label_str: t("search_all") },
          ]
        : [];
    if (modeValueList.length > 1) {
      searchCols.unshift({
        field: "searchSelect",
        inputType: "select",
        placeholder: "search_type_select",
        tooltip: "search_type_select",
        valueList: modeValueList,
        inputClassName: dc.searchSelectWidth,
        onChange: (e) => {
          changeSelectValue(formName, e.value);
          //alert(e.value);
        },
      });
    }
    searchCols.push({
      ...dc.iconButton("ListMagnifyingGlass", undefined, "search_start", "px-2"),
      field: "searchButton",
    });
  }
  return searchCols;
};

const changeSearchParams = (searchParams: ReadonlyURLSearchParams | undefined, value: any, historyPush?: boolean) => {
  if (typeof history.pushState != "undefined") {
    const params = new URLSearchParams(searchParams?.toString());
    Debug("changeSearchParams", params, value);
    Object.keys(value).forEach((key) => {
      const checkValue = value[key];
      if (checkEmpty(checkValue)) {
        if (params.has(key)) {
          params.delete(key);
        }
      } else {
        if (params.has(key)) {
          params.set(key, checkValue);
        } else {
          params.append(key, checkValue);
        }
      }
    });
    // params.set(target, value);
    const params_str = params.toString();
    const url = window.location.origin + window.location.pathname + (params_str && params_str !== "" ? "?" : "") + params_str;
    if (window.location.href !== url) {
      if (historyPush ?? true) {
        history.pushState(null, "", url);
      } else {
        window.location.href = url;
      }
    }
  } else {
    //브라우저가 지원하지 않는 경우 처리
  }
  //Debug("changeSearchParams", value);
};

const changeListParams = (
  searchParams: ReadonlyURLSearchParams | undefined,
  target: string,
  defaultValue: string | undefined,
  value: string | undefined,
  historyPush?: boolean,
) => {
  if (typeof history.pushState != "undefined") {
    const params = new URLSearchParams(searchParams?.toString());
    if (defaultValue === value || value === undefined) {
      if (params.has(target)) {
        params.delete(target);
      }
    } else {
      params.set(target, value);
    }
    const params_str = params.toString();
    const url = window.location.origin + window.location.pathname + (params_str && params_str !== "" ? "?" : "") + params_str;
    //const search = window.location.search;
    if (window.location.href !== url) {
      if (historyPush ?? true) {
        history.pushState(null, "", url);
      } else {
        window.location.href = url;
      }
    }
  } else {
    //브라우저가 지원하지 않는 경우 처리
  }
  Debug("changeListParams", target, defaultValue, value);
};

const changePageFixed = (setPage: Dispatch<SetStateAction<number>>, targetPage: number, historyPush?: boolean) => {
  if (typeof history.pushState != "undefined") {
    //let url = window.location.href;
    const params = new URLSearchParams(window.location.search);
    //const search = window.location.search;
    if (targetPage > 1) {
      params.set("page", targetPage + "");
    } else {
      params.delete("page");
    }
    const params_str = params.toString();
    const url = window.location.origin + window.location.pathname + (params_str && params_str !== "" ? "?" : "") + params_str;
    if (historyPush ?? true) {
      history.pushState(null, "", url);
    } else {
      window.location.href = url;
    }
  } else {
    //브라우저가 지원하지 않는 경우 처리
  }
  Debug("changePageFixed : " + targetPage);
  setPage(targetPage);
};

export default function DataList(params: ListParams) {
  // Debug("DataList", params);
  const formName = params.listName ? params.listName + "_Form" : params.page?.page ? params.page?.page + "_Form" : "DefaultList_Form";
  const url = params.fetchUrl ? params.fetchUrl : ""; //+ (params.fetchUrl.indexOf("?") > -1 ? "&" : "?") : "";
  const option = params.fetchOption ?? dv.fetchOption;

  const t = useTranslations("contents");
  const router = useRouter();
  const searchParams = useSearchParams();

  // const error_str = t("error_text");
  const searchSelect = searchParams?.get("searchSelect") ?? "";
  const page_param = parseInt(searchParams?.get("page") ?? "1");

  const init = useRef(false);
  const [form] = useForm();
  const [pathname, setPathname] = useState(params.pathname);
  // const [searchParamStr, setSearchParamStr] = useState(searchParams?.toString());
  const searchParamStr = useRef(searchParams?.toString());
  const [listUrl, setListUrl] = useState("");
  const [cols, setCols] = useState<DataColumn[]>(initDataCols(params.listCols));
  const [isMobile, setMobile] = useState(params.isMobile ?? checkMobile());

  //const [isMobile, setMobile] = useState(checkMobile());
  useEffect(() => {
    let now_mobile = isMobile;
    let width = 0;
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target.tagName === "BODY") {
          if (width !== entry.contentRect.width) {
            width = entry.contentRect.width;
            const check_mobile = checkMobile();
            if (now_mobile != check_mobile) {
              Debug("change mobile", now_mobile, check_mobile);
              now_mobile = check_mobile;
              setMobile(() => check_mobile);
            }
          }
        }
      });
    });

    if (document.body) {
      resizeObserver.observe(document.body);
    }

    return () => {
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [data, setData] = useState<any[] | undefined>(isMobile ? [{}, {}, {}] : [{}, {}, {}, {}, {}]);
  const [dataStatus, setDataStatus] = useState<boolean>(false);
  const [writeAble, setWriteAble] = useState<boolean>(false);
  const [codeGroups, setCodeGroups] = useState<Record<string, any[]> | undefined | null>(undefined);
  const [page, setPage] = useState<number>(Number.isNaN(page_param) ? 1 : page_param);
  const lastPage = useRef(page);
  const [pagination, setPagination] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(params.loading ?? false);
  const [reload, setReload] = useState(false);
  const [formMemo, setFormMemo] = useState<Record<string, string>>({});
  const [formFunction, setFormFunction] = useState<Record<string, Record<string, Function>>>({});
  const [setValueList, setSetValueList] = useState<Record<string, Function>>({});
  const [descUse, setDescUse] = useState(false);
  const [searchCols, setSearchCols] = useState(getSearchCols(formName, params, searchSelect, t));
  const [orderCols, setOrderCols] = useState(
    getOrderCountCols(t, params.listOrder, params.listOrderInputClassName, params.listCount, params.listCountInputClassName, isMobile),
  );
  const [checkId, setCheckId] = useState<Record<string, string>>({});
  const changePage = (targetPage: number) => {
    changePageFixed(setPage, targetPage, params.historyPush);
  };

  const writePage = () => {
    if (params.listColLink != null) {
      const search = window.location.search;
      if (!(params.listColLink instanceof String)) {
        //location.href = params.page.link + "/write" + search.replace("mode=edit", "");
        params.listColLink("write");
      } else {
        location.href = params.listColLink + "write" + search.replace("mode=edit", "");
      }
    }
  };
  const thClick = function (id: any) {
    if (params.listColLink != null) {
      const search = window.location.search;
      const hrefUrl = params.listColLink + id + search;
      appRouterPush(router, hrefUrl);
      // router.push(hrefUrl);
      //location.href = hrefUrl;
    }
  };
  const searchClick: Function = (tempCols: DataColumn[]) => {
    let hasSearchType = false;
    let hasDateType: Record<string, string> = {};
    const list = tempCols
      .map((item) => {
        if (item.inputType && DatePickerTypeArray.includes(item.inputType)) {
          hasDateType[item.field] = item.inputType;
        }
        if (item.field === "searchType") {
          hasSearchType = true;
        }
        if (item.field !== "searchButton") {
          return item.field;
        } else {
          return undefined;
        }
      })
      .filter((item) => item !== undefined);
    const values = form.getFieldsValue(list);
    //Debug("searchTitle", checkEmpty(values["searchTitle"]));
    //Debug(hasSearchType);
    if (hasSearchType) {
      //Debug("searchTitle", checkEmpty(values["searchTitle"]), values);
      if (checkEmpty(values["searchTitle"])) {
        //Debug("clear searchType");
        values["searchType"] = undefined;
      }
      if (checkEmpty(values["searchType"])) {
        //Debug("clear searchTitle");
        values["searchTitle"] = undefined;
      }
    }

    Object.keys(hasDateType).forEach((item) => {
      if (!checkEmpty(values[item])) {
        if (values[item] instanceof Array) {
          values[item] = values[item].map((value: any) => {
            if (value.$isDayjsObject) {
              value = getDayjsValueStr(value as Dayjs, hasDateType[item]);
            }
          });
        } else {
          if (values[item].$isDayjsObject) {
            values[item] = getDayjsValueStr(values[item] as Dayjs, hasDateType[item]);
          }
        }
      }
    });
    if (!hasSearchNoValue(list, values)) {
      // values["searchSelect"] = undefined;
      // form.setFieldValue("searchSelect", undefined);
      // changeSelectValue(formName, undefined);
    }
    Debug("start changeSearchParams");
    changeSearchParams(searchParams ?? undefined, values);
  };

  const tableClass = params.listName == null ? "" : "table-" + (params.listName ?? "") + "-";
  const paging = () => {
    return pagination ? (
      <Pagination
        paging={pagination}
        pagingCount={isMobile ? 5 : 10}
        setpage={changePage}
        gap={params.pagingGap ?? dv.pagingGap}
        className={cn(params.pagingClassName ?? dv.pagingClassName)}
        buttonClassName={params.pagingButtonClassName}
        activeButtonClassName={params.pagingActiveClassName ?? dv.pagingActiveClassName}
      />
    ) : (
      <div
        className={cn(
          params.blankClassName ?? dv.blankClassName,
          " hidden ml-2 hover:bg-[var(--accent-a3)] md:mx-3 md:max-w-full mx-auto max-w-[94vw] justify-end mt-6 mb-8",
          "",
        )}
      >
        <span className="justify-center"></span>
      </div>
    );
  };

  const [tableModeClass, setTableModeClass] = useState(checkListShow(params.listMode, params.listShow));

  //코드그룹 데이터 조회
  const [groupList, setGroupList] = useState<string[]>([]);
  const [listClickMulti, setListClickMulti] = useState(true);
  const [listEditMode, setListEditMode] = useState<string | undefined>(undefined);
  const listLinkIds = useRef<any[]>([]);
  const listTempValues = useRef<any>(undefined);

  useEffect(() => {
    if (params.codeGroups === undefined) {
      const list_groups = getColsGroups(params.listCols);
      const list_search = getColsGroups(params.listSearch);
      const list_desccodes: DataCols = {};
      const listColdescs = params.listColDesc ? (params.listColDesc instanceof Array ? params.listColDesc : [params.listColDesc]) : [];
      listColdescs.forEach((listColdesc) => {
        const col = typeof listColdesc === "string" ? { field: listColdesc } : listColdesc;
        list_desccodes[col.field] = col;
      });
      const list_desc = getColsGroups(list_desccodes);
      const merge = mergeArr(list_groups, list_search, list_desc);
      Debug("groupList List : ", merge);

      if (merge) {
        if (groupList === undefined || merge.length !== groupList.length || merge.some((item) => !groupList.includes(item))) {
          Debug("change groups in list");
          setGroupList(merge);
          getCodeGroups(merge, params.locale, setCodeGroups);
        }
      } else {
        setCodeGroups({});
      }
    } else {
      setCodeGroups(params.codeGroups);
    }
  }, [params.codeGroups, params.locale, params.listCols, params.listSearch, params.listColDesc, groupList]);

  useEffect(() => {
    setSearchCols(getSearchCols(formName, params, searchSelect, t));
  }, [formName, t, searchSelect, params.listSearch, params.listSearchAll, params.listSearchSelect, params.listSearchSelectClassName]);

  useEffect(() => {
    //Debug("check FormMemo", params.formMemo, params.page);
    setFormMemo({});
    setFormFunction({});
    setSetValueList({});
  }, [params.page.page]);

  //페이지 데이터 조회
  //list_count=10
  useEffect(() => {
    const nowMobile = checkMobile();
    const changePathname = params.pathname !== pathname;
    if (changePathname) {
      Debug("changePathname", params.pathname, pathname);
      setPathname(params.pathname);
    }
    if (params?.pageAuth?.listview ?? true) {
      const authStr = params.pageAuth?.userAuth ? "|" + JSON.stringify(params.pageAuth.userAuth) : "";
      if (codeGroups && (!params.page.auth || authStr !== "")) {
        //(?|&)mode=(edit|write) 제거하기
        const searchParamCheck = searchParams?.toString().replace(/(\?|&)?mode=(edit|write)/g, "") + authStr;
        const changeOrderCols = getOrderCountCols(
          t,
          params.listOrder,
          params.listOrderInputClassName,
          params.listCount,
          params.listCountInputClassName,
          nowMobile,
        );
        //Debug("change OrderCols", isMobile, changeOrderCols);
        const changed = checkColsValueListChange(orderCols, changeOrderCols);
        //Debug("changed", changed);

        if (!init.current || (init.current && (reload || searchParamStr.current !== searchParamCheck || changed || changePathname))) {
          //(?|&)mode=(edit|write) 제거하기
          //lastPage.current != page ||  제거 - searchParamCheck에서 페이지 체크 되기 때문에
          Debug(
            "setList Data : ",
            searchParams?.toString() +
              ",init : " +
              init.current +
              ",reload : " +
              reload +
              ",changed : " +
              changed +
              ", pageChange : " +
              lastPage.current +
              "-" +
              page +
              ", changePathname : " +
              changePathname,
            "searchParamCheck : " + searchParamCheck,
            "searchParamStr.current : " + searchParamStr.current,
          );
          //Debug(lastPage.current + "," + page + "," + init);
          lastPage.current = page;
          searchParamStr.current = searchParamCheck;

          const temp_url = ((params.fetchHost ?? dv.fetchHost) ? getApiHostname() : "") + url; // + "page=" + page + "&list_count=" + (isMobile ? 7 : 10);
          const changeSearchCols = changePathname ? getSearchCols(formName, params, searchSelect, t) : searchCols;
          const setValues: Record<string, any> = {};

          const url_param = getAPISearchParamsValue(searchParams ?? undefined, changeSearchCols, changeOrderCols);
          //Debug("orderCols", nowMobile, changeOrderCols);
          if (url_param.has("page")) {
            url_param.set("page", page + "");
          } else {
            url_param.append("page", page + "");
          }
          if (!url_param.has("list_count")) {
            url_param.append("list_count", (nowMobile ? 5 : 10) + "");
          } else {
            const change_list_count = url_param.get("list_count");
            const now_list_count = form.getFieldValue("list_count");
            if (now_list_count || now_list_count !== change_list_count) {
              setValues["list_count"] = Number(change_list_count);
            }
          }
          if (url_param.has("searchSelect")) {
            url_param.delete("searchSelect");
          }
          if (url_param.has("searchTitle") && !url_param.has("searchType")) {
            const listSelect = params.listSearchSelect ? initDataColCheck(params.listSearchSelect) : undefined;
            if (listSelect && listSelect.length > 0) {
              url_param.append("searchType", listSelect[0].field);
            }
          }

          const body_data: Record<string, any> = {};
          const keys = Array.from(url_param.keys());
          keys.forEach((key) => {
            body_data[key] = url_param.get(key);
          });

          //Debug(body_data, temp_url + "?" + url_param.toString());
          const changeUrl = temp_url + "?" + url_param.toString() + authStr;
          if (!changePathname && !reload && listUrl === changeUrl) {
            return;
          }
          if (listUrl !== changeUrl) {
            setListUrl(changeUrl);
          }
          setReload(false);
          setLoading(true);

          if (changed || changePathname) {
            Debug("changeOrderCols", changeOrderCols);
            changeOrderCols?.forEach((col) => {
              setValues[col.field] = col.defaultValue ?? undefined;
              // form.setFieldValue(col.field, col.defaultValue);
            });
          }
          if (changePathname) {
            Debug("setSearchCols", changeSearchCols);
            changeSearchCols?.forEach((col) => {
              // if (col.field === "searchSelect") {
              setValues[col.field] = col.defaultValue ?? undefined;
              // form.setFieldValue(col.field, col.defaultValue);
              // }
            });
            //
          }
          if (changed || changePathname) {
            if (changePathname) {
              setSearchCols(changeSearchCols);
              setOrderCols(changeOrderCols);
            } else {
              setOrderCols(changeOrderCols);
            }
          }
          if (Object.keys(setValues).length > 0) {
            Debug("List Search Form Values", setValues);
            // setValues.searchSelect = null;
            form.setFieldsValue(setValues);
            // setTimeout(() => {}, dc.setTimeoutDelay);
          }
          if (listLinkIds.current.length > 0) {
            Debug("listLinkids list : clear - ", [...listLinkIds.current], listEdit);
            listLinkIds.current = [];
          }

          fetchUtil(
            temp_url,
            {
              ...option,
              mode: "cors",
              credentials: "include",
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(body_data),
            },
            params.page.auth,
            (data: any) => {
              Debug(data);
              let result: any[] | undefined;
              let pagination;
              let temp_write_able = false;
              if (data?.result !== null) {
                if (params.listResultName != null && data.result[params.listResultName] != null) {
                  result = data.result[params.listResultName];
                  pagination = data.paginationMap[params.listResultName];
                } else {
                  result = data.result;
                  pagination = data.pagination;
                }
              }
              if (data.status) {
                setDataStatus(data.status === "OK" || data.status === "200");
                if (params.writeCheck !== undefined && params.writeCheck !== false) {
                  const write_target = params.writeCheck === "string" ? params.writeCheck : "write_check";
                  if (data[write_target] !== undefined) {
                    temp_write_able = data[write_target] === 1;
                  }
                } else {
                  temp_write_able = true;
                }
              }
              if (result == null || result == undefined || result.length == 0 || (data.status !== "OK" && data.status !== "200")) {
                //const nodata = getDataStatusText(data.status);
                const nodata = t(fetchStatusText(data.status, params.user ? false : true) ?? data.description);
                const result_nodata = getNoData(nodata, data);
                Debug(nodata, data, result_nodata);

                setCols(initDataCols(["nodata_field"]));
                //Debug(nodata);
                setData(() => {
                  return [{ nodata_field: result_nodata }];
                }); //+ "-" + error.toString()
                setPagination(null);
              } else {
                if (params.listCols == null && result.length > 0) {
                  setCols(() => {
                    return initDataCols(Object.keys(result[0]));
                  });
                }
                setCols(initDataCols(params.listCols));
                setData(() => {
                  return result;
                });
                setPagination(pagination);
              }
              setWriteAble(temp_write_able);
              setLoading(false);
              if (Object.keys(setValues).length > 0) {
                Debug("List Search Form Values", setValues);
                form.setFieldsValue(setValues);
              }
            },
            (error: any) => {
              Debug(error);
              setDataStatus(error.status);
              setCols(initDataCols(["error_field"]));
              setData([{ error_field: t("error_text") }]); //+ "-" + error.toString()
              setLoading(false);
              setPagination(null);
              if (Object.keys(setValues).length > 0) {
                Debug("List Search Form Values", setValues);
                form.setFieldsValue(setValues);
              }
            },
          );
          const pagepop = (e: any) => {
            const page_str = getParamsValue("page");
            if (page_str == null) {
              setPage(1);
            } else {
              setPage(parseInt(page_str));
            }
          };

          if (!init.current) {
            init.current = true;
            setCols(initDataCols(params.listCols));
            window.removeEventListener("popstate", pagepop);
          }
          window.addEventListener("popstate", pagepop);
          // } else {
          //   Debug("check setList Data Block" + searchParams.toString());
        }
      }
    } else {
      setCols(initDataCols(["nodata_field"]));
      setDataStatus(false);
      setWriteAble(false);
      setData(() => {
        const nodata = getDataStatusText();
        return [{ nodata_field: t(nodata) }];
      }); //+ "-" + error.toString()
      setPagination(null);
      setLoading(false);
    }
    if (nowMobile !== isMobile) {
      setMobile(nowMobile);
    }
    setTableModeClass(checkListShow(params.listMode, params.listShow));
  }, [
    form,
    page,
    url,
    option,
    t,
    isMobile,
    codeGroups,
    reload,
    searchParamStr,
    searchParams,
    // searchCols,
    // orderCols,
    listUrl,
    params.user,
    params.listResultName,
    params.listCols,
    params.listSearchSelect,
    params.listOrder,
    params.listOrderInputClassName,
    params.listCount,
    params.listCountInputClassName,
    params.fetchHost,
    // params.listMode,
    params.page,
    params.pageAuth?.userAuth,
    params.pageAuth?.listview,
    params.isMobile,
    params.writeCheck,
  ]);
  //Debug("check FormMemo", params.formMemo, params.page);
  useEffect(() => {
    if (params.loading !== undefined && loading !== params.loading) {
      setLoading(params.loading);
    }
  }, [params.loading]);

  const setListEditModeChange = (mode: string | undefined) => {
    if (!listEditMode && mode) {
      listTempValues.current = form.getFieldsValue();
    }
    if (mode === undefined || listEditMode !== mode) {
      if (listEditMode && !mode && listTempValues.current) {
        Debug(listTempValues.current);
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(listTempValues.current);
          if (listLinkIds.current.length > 0) {
            Debug("listLinkids list : ", [...listLinkIds.current]);
            Debug("listLinkids list : clear");
            listLinkIds.current = [];
          }
          setListEditMode((prev) => {
            return mode;
          });
        }, dc.setTimeoutShort);
      } else {
        if (listLinkIds.current.length > 0) {
          Debug("listLinkids list : ", [...listLinkIds.current]);
          Debug("listLinkids list : clear");
          listLinkIds.current = [];
        }
        setListEditMode((prev) => {
          return mode;
        });
      }
    }
  };

  useEffect(() => {
    Debug("change params.dataId, params.listMode : ", params.dataId, params.listMode);
    // if (!listClickMulti || multiMax < 2) {
    // }
    setCheckId({});
    setListEditModeChange(undefined);
  }, [params.dataId, params.listMode]);

  useEffect(() => {
    Debug("change params.page : ", params.page);
    setCheckId({});
    setListEditModeChange(undefined);
    if (pathname !== params.page.link) {
      init.current = false;
    }
  }, [params.page]);

  useEffect(() => {
    if (listLinkIds.current.length > 0) {
      Debug("listLinkids list : ", [...listLinkIds.current]);
    }
    if (!listEditMode) {
      Debug("listLinkids list : clear");
      listLinkIds.current = [];
    }
  }, [listEditMode]);

  if (params.dataFunction) {
    params.dataFunction["setListReload"] = () => {
      setReload(true);
    };
    params.dataFunction["getSearchCols"] = () => {
      return searchCols;
    };
    params.dataFunction["setListEditSaved"] = () => {
      Debug("setListEditSaved : ", listTempValues.current);
      listTempValues.current = undefined;
      setReload(true);
      setTimeout(() => {
        setListEditModeChange(undefined);
      }, dc.setTimeoutDelay);
    };
  }
  const listClick =
    params.listMode && ((params.listMode === "view" && !checkEmpty(params.dataId)) || params.listMode !== "view") && params?.dataFunction
      ? params.dataFunction[params.listMode + "ListClick"]
      : undefined;

  const listClickButton =
    listClick && params.listClickButton
      ? ((params.listMode === "view"
          ? params.listClickButton.read
          : params.listMode === "write"
            ? (params.listClickButton.create ?? params.listClickButton.edit)
            : params.listMode === "edit"
              ? (params.listClickButton.update ?? params.listClickButton.edit)
              : params.listClickButton) ?? params.listClickButton)
      : undefined;
  const listCancel = params?.dataFunction && params.listMode ? params.dataFunction[params.listMode + "ListCancel"] : undefined;
  const listCancelButton = listCancel
    ? params.listCancelButton
      ? ((params.listMode === "view"
          ? params.listCancelButton.read
          : params.listMode === "write"
            ? (params.listCancelButton.create ?? params.listCancelButton.edit)
            : params.listMode === "edit"
              ? (params.listCancelButton.update ?? params.listCancelButton.edit)
              : params.listCancelButton) ?? params.listCancelButton)
      : listClickButton
    : undefined;
  const { listEdit, listEditFields } =
    params.listMode === "view" && checkEmpty(params.dataId) && params.listEdit
      ? getListEdit(params.listEdit instanceof Array ? params.listEdit : [params.listEdit], listEditMode)
      : {};

  //타이틀 관련 설정
  const titleColOrg = isMobile ? (params.listColMobileTitle ?? params.listColTitle) : params.listColTitle;
  const titleCol = titleColOrg ? (typeof titleColOrg === "string" ? { field: titleColOrg } : titleColOrg) : undefined;
  const titleColspan =
    cols && (titleColOrg || params.listColDesc)
      ? (isMobile && params.mobileHidden
          ? cols.filter((col) => (params.mobileHidden ? !params.mobileHidden.includes(col.field) : true)).length - 1
          : cols.length - 1) + (listClickButton ? 1 : 0)
      : undefined;

  //요약모드 관련 설정
  const listColDesc = params.listColDesc;
  const tempListColDescProp =
    params.listColDescProp ??
    (listColDesc && !(listColDesc instanceof Array) ? (typeof listColDesc === "string" ? { field: listColDesc } : listColDesc) : {});
  const listColDescProp = { ...dc.defaultListColDescProp, ...tempListColDescProp };
  Debug("ListMode : " + params.listMode + "ListClick, dataId : " + params.dataId, ", CheckId : ", checkId);

  const multiMax = params.listClickMulti
    ? typeof params.listClickMulti === "boolean"
      ? params.listClickMulti
        ? listClickMultiDefault
        : 1
      : params.listClickMulti
    : 1;
  const checkIdList = Object.keys(checkId);
  const checkIdValueList: DefaultOptionType[] | undefined =
    checkIdList.length > 0
      ? checkIdList.map((id): DefaultOptionType => {
          return { value: id, label: checkId[id] };
        })
      : undefined;

  return (
    <Container
      className={cn(
        "table-" + (params.listName ?? "default_list"),
        params.listClassName ?? dv.listClassName,
        tableModeClass,
        "table_list_mode_" + params.listMode,
        " animate-fade animate-once animate-duration-150 animate-ease-in",
      )}
    >
      <Form form={form} name={formName} className={cn(formName, params.listFormClassName)}>
        {/* 검색 버튼 시작 */}
        {searchCols && searchCols.length > 0 ? (
          <Flex className={cn("ListSearchForm", params.listSearchClassName ?? dv.listSearchClassName ?? "justify-end mb-4")}>
            {searchCols.map((col) => {
              const inputName = col.field;
              // Debug("searchCols", inputName, col);
              const value = checkValueList(col.valueList, searchParams?.get(inputName)) ?? col.defaultValue;
              switch (inputName) {
                case "searchButton":
                  const ep = col.elementProp;
                  if (typeof ep !== "string" && ep?.buttonProp) {
                    ep.buttonProp.onClick = () => {
                      searchClick(searchCols);
                    };
                  }
                  break;
                case "searchTitle":
                  const temp_press = col.onPressEnter;
                  col.onPressEnter = (e) => {
                    if (temp_press) {
                      temp_press(e);
                    }
                    searchClick(searchCols);
                  };
                  break;
                case "searchSelect":
                  break;
                default:
                  //const temp_func = col.onChange;
                  col.onChange = (e) => {
                    // if (temp_func) {
                    //   temp_func(e);
                    // }
                    if ((params.listSearchChange ?? true) && form.getFieldValue("searchSelect") !== "search_all") {
                      Debug("searchClick start", col.field);
                      searchClick(searchCols);
                    }
                  };
                  if (!col.selectProp) {
                    col.selectProp = {};
                  }
                  const sp = col.selectProp;
                  if (sp) {
                    sp.onInputKeyDown = (e) => {
                      if (e.code === "Backspace" && !e.shiftKey) {
                        const target = e.target as HTMLInputElement;
                        if (target.value === "") {
                          form.setFieldValue(inputName, undefined);
                          if ((params.listSearchChange ?? true) && form.getFieldValue("searchSelect") !== "search_all") {
                            searchClick(searchCols);
                          }
                        }
                      }
                    };
                  }
                  break;
              }
              //Debug(inputName);
              return (
                <DataInput
                  key={formName + col.field + (loading ? "_loading" : "")}
                  form={form}
                  formMemo={formMemo}
                  formFunction={formFunction}
                  setValueList={setValueList}
                  values={data}
                  inputMode={"search"}
                  loading={loading && !init.current}
                  id={formName + inputName}
                  name={inputName}
                  labelUse={params.listSearchLabelUse ?? false}
                  labelTransition={params.listSearchLabelTransition}
                  locale={params.locale}
                  codeGroups={codeGroups}
                  userSeq={params.user?.userseq}
                  userType={params.user?.usertype}
                  userAuth={params.pageAuth?.userAuth}
                  inputType={loading ? "" : col.inputType}
                  {...col}
                  value={value}
                />
              );
            })}
          </Flex>
        ) : (
          ""
        )}
        {checkIdValueList && checkIdValueList.length > 0 ? (
          <Flex className={cn("ListCheckIdForm", "justify-end mb-4")}>
            <Select
              mode="multiple"
              value={checkIdList}
              options={checkIdValueList}
              maxCount={multiMax}
              allowClear={true}
              className="mr-2"
              onChange={(change) => {
                const changeCheck = { ...checkId };
                const remove = checkEmpty(change) ? checkIdList : checkIdList.filter((item) => !change.includes(item));
                remove.forEach((item) => {
                  delete changeCheck[item];
                  if (listCancel) {
                    listCancel(item);
                  }
                });
                setCheckId(changeCheck);
              }}
            />
            <DataInput
              key={formName + "_list_check_multi_use" + (loading ? "_loading" : "")}
              form={form}
              values={undefined}
              loading={loading && !init}
              labelUse={false}
              locale={params.locale}
              userSeq={params.user?.userseq}
              userType={params.user?.usertype}
              userAuth={params.pageAuth?.userAuth}
              value={listClickMulti}
              onChange={(e) => {
                // Debug(e);
                setTimeout(() => {
                  if (e.value !== listClickMulti) {
                    setListClickMulti(() => e.value);
                  }
                }, dc.setTimeoutShort);
              }}
              inputType="switchButton"
              id={formName + +"_list_check_multi_use"}
              fieldId={undefined}
              name={"list_check_multi_use"}
              // itemClassName="mr-auto"
              valueClassName="!pt-0"
              switchButtonProp={{
                checkedChildren: { type: "primary", iconName: "ListChecks" },
                unCheckedChildren: { iconName: "Check" },
                buttonName: "ListChecks",
              }}
            />

            {/* {listClickMulti ? (
            ) : undefined} */}
          </Flex>
        ) : undefined}
        {/* 검색 버튼 끝 */}
        <Table.Root variant={params.listVariant ?? dv.listVariant}>
          {(params.listHeader ?? true) ? (
            <Table.Header>
              <Table.Row key={params.listName + "_header"}>
                {cols.map((col, index) => {
                  if (
                    col.field === "" ||
                    (isMobile && params.mobileHidden && params.mobileHidden.includes(col.field)) ||
                    (titleCol && titleCol.field === col.field)
                  ) {
                    return undefined;
                  }
                  const fieldEditMode =
                    listEditFields && listEditFields[col.field] && listEditFields[col.field].length === 1
                      ? listEditFields[col.field][0]
                      : undefined;
                  const cellText = t(typeof col.label === "string" ? col.label : (params.listTitlePrev ?? "") + col.field);

                  const header_cell = (
                    <Table.ColumnHeaderCell
                      key={params.listName + "_" + col.field}
                      className={cn(
                        tableClass + "header-" + col.field,
                        "table-cell-" + index,
                        col.className,
                        params.listHeaderClassName ?? dv.listHeaderClassName,
                        fieldEditMode ? "" : "cursor-default align-middle",
                      )}
                    >
                      <Skeleton loading={loading && !init.current}>
                        {fieldEditMode ? (
                          <Button
                            type="button"
                            variant={listEditMode === fieldEditMode ? "solid" : "soft"}
                            className="cursor-pointer"
                            onClick={() => {
                              if (listEditMode === fieldEditMode) {
                                setListEditModeChange(undefined);
                              } else {
                                setListEditModeChange(fieldEditMode);
                              }
                            }}
                          >
                            {cellText}
                          </Button>
                        ) : (
                          cellText
                        )}
                      </Skeleton>
                    </Table.ColumnHeaderCell>
                  );
                  if (listClickButton && (listClickButton.order ?? 0) === index) {
                    return (
                      <React.Fragment key={params.listName + "_link_btn_cover"}>
                        <Table.ColumnHeaderCell key={params.listName + "_link_btn"}>
                          <Skeleton loading={loading}>&nbsp;</Skeleton>
                        </Table.ColumnHeaderCell>
                        {header_cell}
                      </React.Fragment>
                    );
                  } else {
                    return header_cell;
                  }
                })}
              </Table.Row>
            </Table.Header>
          ) : (
            ""
          )}
          <Table.Body>
            {data && data instanceof Array
              ? data.map((item, index) => {
                  const linkFieldValue = params.listColLinkField
                    ? typeof params.listColLinkField === "string"
                      ? linkFieldConvert(params.listColLinkField, item[params.listColLinkField], params.uriField, params.base64Field, true)
                      : params.listColLinkField
                          .map((field) => linkFieldConvert(field, item[field], params.uriField, params.base64Field, true))
                          .filter((item) => item !== undefined)
                          .join(params.listColLinkFieldJoin ?? "_")
                    : null;
                  // Debug(params.listColLinkField, linkFieldValue);
                  if (!loading && init) {
                    if (!checkEmpty(linkFieldValue) && !listLinkIds.current.includes(linkFieldValue)) {
                      // Debug("listLinkids list : push - " + linkFieldValue);
                      listLinkIds.current.push(linkFieldValue);
                    }
                  }

                  const titleRow = titleCol
                    ? getTableCell(
                        t,
                        params,
                        titleCol,
                        codeGroups,
                        linkFieldValue,
                        item,
                        index,
                        0,
                        tableClass,
                        undefined,
                        undefined,
                        undefined,
                        loading,
                        false,
                        titleColspan,
                      )
                    : undefined;
                  const descRows =
                    listColDesc && descUse
                      ? getTableCellList(
                          t,
                          params,
                          listColDesc,
                          codeGroups,
                          linkFieldValue,
                          item,
                          index,
                          0,
                          tableClass,
                          undefined,
                          undefined,
                          loading,
                          true,
                          titleCol ? titleColspan : (titleColspan ?? 0) + 1,
                        )
                      : undefined;

                  const linkClick =
                    linkFieldValue === params.dataId
                      ? undefined
                      : checkIdList.includes(linkFieldValue)
                        ? params.listMode === "view"
                          ? undefined
                          : listCancel
                        : // linkFieldValue === params.dataId || (checkId.includes(linkFieldValue) && params.listMode === "view")
                          // ? undefined
                          listClick && ((params.listMode === "view" && !listClickButton) || params.listMode !== "view")
                          ? listClick
                          : params.listColLink !== null && linkFieldValue !== null && linkFieldValue !== "" && dataStatus
                            ? params.listColLink != null && params.listColLink instanceof Function
                              ? params.listColLink
                              : thClick
                            : undefined;

                  const linkClassName = !checkEmpty(params.dataId)
                    ? linkFieldValue === params.dataId
                      ? "bg-[var(--accent-a3)] NowData"
                      : checkIdList.includes(linkFieldValue)
                        ? "bg-[var(--gray-a3)] CheckData"
                        : ""
                    : "";
                  const boldList = params.listColBold
                    ? descRows && params.listColDescBold
                      ? [...params.listColBold, ...params.listColDescBold]
                      : params.listColBold
                    : descRows
                      ? params.listColDescBold
                      : undefined;
                  const rows = cols.map((col, colIndex) => {
                    //const value = getCodeLabel(item[col.field], codeGroups, col.codeGroup, params.locale);
                    if (
                      col.field === "" ||
                      (isMobile && params.mobileHidden && params.mobileHidden.includes(col.field)) ||
                      (titleCol && titleCol.field === col.field)
                    ) {
                      return undefined;
                    }
                    const cell = getTableCell(
                      t,
                      params,
                      col,
                      codeGroups,
                      linkFieldValue,
                      item,
                      index,
                      colIndex,
                      tableClass,
                      undefined,
                      boldList,
                      listEdit,
                      loading,
                      false,
                      undefined,
                    );
                    if (listClickButton && listClickButton.order === colIndex) {
                      const listClickDisplay = checkListButtonDisplay(listClickButton, item);
                      const listCancelDisplay = checkListButtonDisplay(listCancelButton, item);
                      return (
                        <React.Fragment key={params.listName + "_" + colIndex + "_link_btn_cover"}>
                          <Table.Cell
                            key={params.listName + "_" + colIndex + "_link_btn"}
                            className={cn(listClickButton.cellClassName, "align-middle", linkClick ? "cursor-default" : "")}
                            onClick={
                              (listClickDisplay && linkClick && listClick) ||
                              (listCancelDisplay && checkIdList.includes(linkFieldValue) && listCancel)
                                ? (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (linkFieldValue !== params.dataId) {
                                      if (listClick && !checkIdList.includes(linkFieldValue)) {
                                        const title = listClick
                                          ? params.listClickTitle
                                            ? getSummaryValues(t, params.listClickTitle, codeGroups, item, params.locale, true)
                                            : linkFieldValue
                                          : undefined;
                                        setCheckId((orgId) => {
                                          const title = params.listClickTitle
                                            ? getSummaryValues(t, params.listClickTitle, codeGroups, item, params.locale, true)
                                            : linkFieldValue;
                                          if (listClickMulti && multiMax > 1) {
                                            if (checkIdList.length < multiMax && !checkIdList.includes(linkFieldValue)) {
                                              const change = { ...orgId };
                                              change[linkFieldValue] = title;
                                              return change;
                                            } else {
                                              return orgId;
                                            }
                                          } else {
                                            if (listCancel) {
                                              setTimeout(() => {
                                                checkIdList.forEach((id) => {
                                                  listCancel(id);
                                                });
                                              }, dc.setTimeoutDelay);
                                            }
                                            const change: Record<string, string> = {};
                                            change[linkFieldValue] = title;
                                            return change;
                                          }
                                        });
                                        listClick(linkFieldValue, title);
                                      } else if (listCancelDisplay && listCancel && checkIdList.includes(linkFieldValue)) {
                                        setCheckId((orgId) => {
                                          if (listClickMulti && multiMax > 1) {
                                            if (checkIdList.includes(linkFieldValue)) {
                                              const change = { ...orgId };
                                              delete change[linkFieldValue];
                                              return change;
                                            } else {
                                              return orgId;
                                            }
                                          } else {
                                            return {};
                                          }
                                        });
                                        listCancel(linkFieldValue);
                                      }
                                    }
                                  }
                                : undefined
                            }
                          >
                            <Skeleton loading={loading}>
                              {listClickDisplay &&
                              linkClick &&
                              linkFieldValue !== params.dataId &&
                              !checkIdList.includes(linkFieldValue) ? (
                                <Icon
                                  iconType=""
                                  iconName={listClickButton.iconName ?? ""}
                                  className={cn(listClickButton.iconClassName, "cursor-pointer")}
                                />
                              ) : listCancelDisplay && checkIdList.includes(linkFieldValue) && listCancel && listCancelButton ? (
                                <Icon
                                  iconType=""
                                  iconName={listCancelButton.iconName ?? ""}
                                  className={cn(listCancelButton.iconClassName, "cursor-pointer")}
                                />
                              ) : undefined}
                            </Skeleton>
                          </Table.Cell>
                          {cell}
                        </React.Fragment>
                      );
                    } else {
                      return cell;
                    }
                    // Debug(item[col.field].$$typeof === "Symbol(react.element)");
                  });
                  // const isLink = params.listColLink !== null && linkFieldValue !== null && linkFieldValue !== "" && dataStatus;
                  // if (isLink && dataStatus) {
                  return (
                    <React.Fragment key={params.listName + "_" + index}>
                      {titleRow ? (
                        <Table.Row
                          key={params.listName + "_title_" + index}
                          onClick={
                            linkClick && (!listClickButton || params.listMode === "view") && !listEdit
                              ? () => {
                                  const title = listClick
                                    ? params.listClickTitle
                                      ? getSummaryValues(t, params.listClickTitle, codeGroups, item, params.locale, true)
                                      : linkFieldValue
                                    : undefined;
                                  if (listClick) {
                                    setCheckId((orgId) => {
                                      if (listClickMulti && multiMax > 1) {
                                        if (checkIdList.length < multiMax && !checkIdList.includes(linkFieldValue)) {
                                          const change = { ...orgId };
                                          change[linkFieldValue] = title;
                                          return change;
                                        } else {
                                          return orgId;
                                        }
                                      } else {
                                        if (listCancel) {
                                          setTimeout(() => {
                                            checkIdList.forEach((id) => {
                                              listCancel(id);
                                            });
                                          }, dc.setTimeoutDelay);
                                        }
                                        const change: Record<string, string> = {};
                                        change[linkFieldValue] = title;
                                        return change;
                                      }
                                    });
                                  }
                                  linkClick(linkFieldValue, title);
                                }
                              : undefined
                          }
                          className={cn(
                            tableClass + "row-" + index,
                            "TitleRow TitleRow-" + index,
                            params.listColClassName ?? dv.listColClassName,
                            (params.listColTitleBold ?? true) ? "font-bold" : "",
                            params.listColTitleClassName,
                            linkClassName,
                            linkClick && (!listClickButton || params.listMode === "view") && !listEdit
                              ? (params.listColLinkHoverClassName ?? dv.listColLinkHoverClassName) + " cursor-pointer"
                              : " cursor-default",
                          )}
                        >
                          {titleRow}
                        </Table.Row>
                      ) : undefined}
                      <Table.Row
                        key={params.listName + "_key_" + index}
                        onClick={
                          linkClick && (!listClickButton || params.listMode === "view") && !listEdit
                            ? () => {
                                const title = listClick
                                  ? params.listClickTitle
                                    ? getSummaryValues(t, params.listClickTitle, codeGroups, item, params.locale, true)
                                    : linkFieldValue
                                  : undefined;
                                if (title) {
                                  setCheckId((orgId) => {
                                    const title = params.listClickTitle
                                      ? getSummaryValues(t, params.listClickTitle, codeGroups, item, params.locale, true)
                                      : linkFieldValue;
                                    if (listClickMulti && multiMax > 1) {
                                      if (checkIdList.length < multiMax && !checkIdList.includes(linkFieldValue)) {
                                        const change = { ...orgId };
                                        change[linkFieldValue] = title;
                                        return change;
                                      } else {
                                        return orgId;
                                      }
                                    } else {
                                      if (listCancel) {
                                        setTimeout(() => {
                                          checkIdList.forEach((id) => {
                                            listCancel(id);
                                          });
                                        }, dc.setTimeoutDelay);
                                      }
                                      const change: Record<string, string> = {};
                                      change[linkFieldValue] = title;
                                      return change;
                                    }
                                  });
                                }
                                linkClick(linkFieldValue, title);
                              }
                            : undefined
                        }
                        className={cn(
                          tableClass + "row-" + index,
                          params.listColClassName ?? dv.listColClassName,
                          titleRow ? "TitleNextRow TitleNextRow-" + index : "",
                          linkClassName,
                          linkClick && (!listClickButton || params.listMode === "view") && !listEdit
                            ? (params.listColLinkHoverClassName ?? dv.listColLinkHoverClassName) + " cursor-pointer"
                            : " cursor-default",
                        )}
                      >
                        {rows}
                      </Table.Row>
                      {descRows
                        ? descRows.map((descRow, descIndex) => {
                            return (
                              <Table.Row
                                key={params.listName + "_desc_" + descIndex}
                                className={cn(
                                  tableClass + "row-" + index,
                                  params.listColClassName ?? dv.listColClassName,
                                  // linkClassName,
                                  descRow.col.itemClassName,
                                  descRow ? "DescRow DescRow-" + index + " DescRowIndex-" + descIndex : "",
                                  // " cursor-default",
                                )}
                              >
                                {descRow.cell}
                              </Table.Row>
                            );
                          })
                        : undefined}
                    </React.Fragment>
                  );
                  // } else {
                  //   return (
                  //     <>
                  //       {titleRow ? (
                  //         <Table.Row
                  //           key={params.listName + "_title_" + index}
                  //           className={cn(
                  //             tableClass + "row-" + index,
                  //             params.listColClassName ?? dv.listColClassName,
                  //             params.listColLinkHoverClassName ?? dv.listColLinkHoverClassName,
                  //             "cursor-pointer",
                  //           )}
                  //         >
                  //           {titleRow}
                  //         </Table.Row>
                  //       ) : undefined}
                  //       <Table.Row
                  //         key={params.listName + "_" + index}
                  //         className={cn(
                  //           tableClass + "row-" + index,
                  //           params.listColClassName ?? dv.listColClassName,
                  //           params.listColLink !== null && dataStatus
                  //             ? (params.listColLinkHoverClassName ?? dv.listColLinkHoverClassName)
                  //             : "",
                  //           "cursor-default",
                  //         )}
                  //       >
                  //         {rows}
                  //       </Table.Row>
                  //     </>
                  //   );
                  // }
                })
              : ""}
          </Table.Body>
        </Table.Root>
        {(orderCols && orderCols.length > 0) || listColDesc ? (
          <Flex className={cn("ListOrderForm", params.listOrderClassName ?? dv.listOrderClassName ?? "justify-end mt-4")}>
            {listColDesc && listColDescProp ? (
              <DataInput
                key={formName + "_list_desc_use" + (loading ? "_loading" : "")}
                form={form}
                values={undefined}
                loading={loading && !init.current}
                labelUse={params.listSearchLabelUse ?? false}
                labelTransition={params.listSearchLabelTransition}
                locale={params.locale}
                userSeq={params.user?.userseq}
                userType={params.user?.usertype}
                userAuth={params.pageAuth?.userAuth}
                value={descUse}
                onChange={(e) => {
                  Debug(e);
                  setDescUse(() => e.value);
                }}
                {...listColDescProp}
                inputType={listColDescProp.inputType ?? "switch"}
                id={formName + +"_list_desc_use"}
                fieldId={undefined}
                name={"list_desc_use"}
              />
            ) : undefined}
            {orderCols
              ? orderCols.map((col) => {
                  const inputName = col.field;
                  const value = checkValueList(col.valueList, searchParams?.get(inputName) ?? col.defaultValue);
                  // Debug("orderCols", inputName, value);
                  return (
                    <DataInput
                      key={formName + inputName + (loading ? "_loading" : "")}
                      form={form}
                      values={data}
                      inputMode={"search"}
                      loading={loading && !init.current}
                      id={formName + inputName}
                      name={inputName}
                      labelUse={params.listSearchLabelUse ?? false}
                      labelTransition={params.listSearchLabelTransition}
                      locale={params.locale}
                      codeGroups={codeGroups}
                      userSeq={params.user?.userseq}
                      userType={params.user?.usertype}
                      userAuth={params.pageAuth?.userAuth}
                      value={value}
                      onChange={(e) => {
                        //Debug(e);
                        if (col.onChange) {
                          col.onChange(e);
                        }
                        if (!checkEmpty(e.value)) {
                          let defaultValue = undefined;
                          let value = undefined;
                          orderCols.forEach((col) => {
                            if (col.field === inputName) {
                              if (col.valueList) {
                                col.valueList.forEach((item, index) => {
                                  if (index === 0) defaultValue = item.value;
                                  if (e.value === item.value) value = item.value;
                                });
                              }
                            }
                          });
                          changeListParams(
                            searchParams ?? undefined,
                            inputName,
                            defaultValue !== undefined ? defaultValue + "" : undefined,
                            value !== undefined ? value + "" : undefined,
                          );
                          //setReload(true);
                        }
                      }}
                      {...col}
                    />
                  );
                })
              : undefined}
            {/* {pagination && pagination.page && pagination.list_count && pagination.total_count ? (
              <DataInput
                key={formName + "_list_pagination_count" + (loading ? "_loading" : "")}
                form={form}
                values={undefined}
                loading={loading && !init.current}
                labelUse={false}
                labelTransition={params.listSearchLabelTransition}
                locale={params.locale}
                userSeq={params.user?.userseq}
                userType={params.user?.usertype}
                userAuth={params.pageAuth?.userAuth}
                value={descUse}
                inputType={"element"}
                elementProp={{
                  element:
                    (pagination.page - 1) * pagination.list_count +
                    1 +
                    ((pagination.page - 1) * pagination.list_count + 1 !==
                    Math.min(pagination.page * pagination.list_count, pagination.total_count)
                      ? "-" + Math.min(pagination.page * pagination.list_count, pagination.total_count)
                      : "") +
                    " / " +
                    pagination.total_count,
                  transition: false,
                  elementType: "button",
                  buttonProp: { color: "default", variant: "filled" },
                }}
                id={formName + +"_list_pagination_count"}
                fieldId={undefined}
                name={"list_pagination_count"}
              />
            ) : undefined} */}
          </Flex>
        ) : (
          ""
        )}{" "}
        {/* 하단 버튼 */}
        <Flex
          align="end"
          // gap={params.gap}
          className={cn(params.listButtonsFlexClassName ?? dv.listButtonsFlexClassName, " max-w-full")}
        >
          {!listEdit && dataStatus && writeAble && (params.writeButton ?? true) && (params?.pageAuth?.write ?? false) ? (
            <Skeleton loading={loading && !init.current}>
              <Button
                type="button"
                variant="soft"
                className={cn(params.writeButtonClassName ?? dv.listCommonButtonClassName, "cursor-pointer")}
                onClick={(e) => {
                  writePage();
                }}
                {...params.writeButtonProps}
              >
                {params.writeButtonIcon === null ? (
                  ""
                ) : params.writeButtonIcon ? (
                  <Icon {...params.writeButtonIcon} />
                ) : dv.writeButtonIcon ? (
                  <Icon {...dv.writeButtonIcon} />
                ) : (
                  ""
                )}
                {t(params.writeButtonTitle ?? "write")}
              </Button>
            </Skeleton>
          ) : (
            ""
          )}
          {listEdit && listEdit.button ? (
            <Skeleton loading={loading && !init.current}>
              <Button
                type="button"
                variant="soft"
                className={cn(listEdit.button.buttonClassName ?? dv.listCommonButtonClassName, "cursor-pointer")}
                onClick={(e) => {
                  // setReload(true);
                  //writePage();
                  const fields = Object.keys(listEdit.field);
                  const valuesField = listLinkIds.current.flatMap((id) => {
                    fields.map((field) => {
                      id + "_" + field;
                    });
                  });
                  const formValues = form.getFieldsValue(valuesField);
                  const orgValues: any = {};
                  data?.forEach((value) => {
                    const idStr =
                      typeof params.listColLinkField === "string"
                        ? linkFieldConvert(
                            params.listColLinkField,
                            value[params.listColLinkField],
                            params.uriField,
                            params.base64Field,
                            true,
                          )
                        : params.listColLinkField
                          ? params.listColLinkField
                              .map((field) => linkFieldConvert(field, value[field], params.uriField, params.base64Field, true))
                              .filter((item) => item !== undefined)
                              .join(params.listColLinkFieldJoin ?? "_")
                          : undefined;
                    orgValues[idStr] = { ...value };
                  });
                  const applyValueList = checkEmptyValue(
                    listLinkIds.current
                      .map((id) => {
                        const orgValue = orgValues[id];
                        const applyField: any = {};
                        if (typeof params.listColLinkField === "string") {
                          applyField[params.listColLinkField] = linkFieldConvert(
                            params.listColLinkField,
                            id,
                            params.uriField,
                            params.base64Field,
                            false,
                          );
                        } else if (params.listColLinkField) {
                          const idFields = params.listColLinkField;
                          id.split(params.listColLinkFieldJoin ?? "_").forEach((value: any, index: number) => {
                            const idField = idFields[index];
                            const c = linkFieldConvert(idField, value, params.uriField, params.base64Field, false);
                            applyField[idField] = c;
                          });
                        }
                        let change = false;
                        fields.forEach((field) => {
                          const changeValue = formValues[id + "_" + field];
                          if (!change && (!orgValue || orgValue[field] !== changeValue)) {
                            change = true;
                          }
                          applyField[field] = changeValue;
                        });
                        // Debug(applyField, orgValue);
                        return change ? applyField : undefined;
                      })
                      .filter((item) => item !== undefined),
                  );
                  // Debug(listLinkIds.current, fields, applyValueList);
                  listEdit.button?.onClick(applyValueList, listLinkIds.current, fields);
                  // form.
                }}
                {...listEdit.button.buttonProps}
              >
                {listEdit.button.buttonIcon === null ? (
                  ""
                ) : listEdit.button.buttonIcon ? (
                  <Icon {...listEdit.button.buttonIcon} />
                ) : dv.saveButtonIcon ? (
                  <Icon {...dv.saveButtonIcon} />
                ) : (
                  ""
                )}
                {t(listEdit.button.buttonTitle ?? "apply_label")}
              </Button>
            </Skeleton>
          ) : (
            ""
          )}
          {(params.listReloadButton ?? true) ? (
            <Skeleton loading={loading && !init.current}>
              <Button
                type="button"
                variant="soft"
                className={cn(params.listReloadButtonClassName ?? dv.listCommonButtonClassName, "cursor-pointer")}
                onClick={(e) => {
                  setReload(true);
                  //writePage();
                }}
                {...params.listReloadButtonProps}
              >
                {params.listReloadButtonIcon === null ? (
                  ""
                ) : params.listReloadButtonIcon ? (
                  <Icon {...params.listReloadButtonIcon} />
                ) : dv.listReloadButtonIcon ? (
                  <Icon {...dv.listReloadButtonIcon} />
                ) : (
                  ""
                )}
                {t(params.listReloadButtonTitle ?? "reload")}
              </Button>
            </Skeleton>
          ) : (
            ""
          )}
        </Flex>
        {(params.pagingFirst ?? false) ? "" : paging()}
      </Form>
    </Container>
  );
}
